export default __webpack_public_path__ + "static/sinc-workforce-logo-e2ac31104c976fdcf80ccf80aeefcce5.svg";